import { useSelector } from 'react-redux';
import { DateTime } from 'luxon';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';
import Global from '../../store/global-selectors';

const USPS_COP_ELIGIBLE_CUTOFF_DATE_UTC = '2026-02-23';

export const useIsMerchantUspsCopEligible = () => {
  const featureFlagEnabled = useFeatureFlag(FeatureFlagDeclarations.enableUspsCopNsaInstruction);
  const couponCode = useSelector(Global.selectSellerCouponCode);
  const sellerCreateDateUtc = useSelector(Global.selectSellerCreateDateUTC);

  // Feature flag override bypasses all checks (for testing/manual targeting)
  if (featureFlagEnabled) {
    return true;
  }

  // Seller must have signed up on or after the cutoff date
  const sellerCreateDate = DateTime.fromISO(sellerCreateDateUtc, { zone: 'utc' });
  const cutoffDate = DateTime.fromISO(USPS_COP_ELIGIBLE_CUTOFF_DATE_UTC, { zone: 'utc' });

  if (!sellerCreateDate.isValid || sellerCreateDate < cutoffDate) {
    return false;
  }

  if (!couponCode) {
    return false;
  }

  // Match the backend regex pattern: @"USPS\d{4}NSA$"
  // This matches ONLY:
  // - USPS####NSA where #### is exactly 4 digits (e.g., USPS1234NSA, USPS5049NSA)
  // Note: NSA suffix is required and must have exactly 4 digits
  const uspsNsaRegex = /^USPS\d{4}NSA$/;

  return uspsNsaRegex.test(couponCode);
};
